export const STAFF_ROUTE_ORDER = [
  '/',
  '/users',
  '/staff',
  '/astrologers',
  '/astrologers/kyc',
  '/astrologers/register',
  '/astrologers/invite',
  '/chat-logs',
  '/transactions',
  '/wallet/coins',
  '/shop/products',
  '/shop/orders',
  '/blogs',
  '/courses',
  '/commissions',
  '/reports/revenue',
  '/reports/gst',
  '/reports/tds',
  '/payouts',
  '/live-streams',
  '/support/tickets',
  '/settings',
  '/settings/payment',
  '/settings/currency',
  '/settings/notifications',
];

export const normalizePath = (path) => {
  if (!path || typeof path !== 'string') return '';
  const [withoutQuery] = path.trim().split(/[?#]/);
  if (!withoutQuery) return '';
  const withSlash = withoutQuery.startsWith('/') ? withoutQuery : `/${withoutQuery}`;
  return withSlash.length > 1 ? withSlash.replace(/\/+$/, '') : '/';
};

export const isPathAllowed = (targetPath, allowedPaths = []) => {
  const normalizedTarget = normalizePath(targetPath);
  if (!normalizedTarget) return false;

  return allowedPaths.some((path) => {
    const normalizedAllowed = normalizePath(path);
    if (!normalizedAllowed) return false;
    if (normalizedAllowed === '/') return normalizedTarget === '/';
    return normalizedTarget === normalizedAllowed || normalizedTarget.startsWith(`${normalizedAllowed}/`);
  });
};

export const getAllowedPaths = (user) => (
  Array.isArray(user?.accessiblePages)
    ? user.accessiblePages.map(normalizePath).filter(Boolean)
    : []
);

export const getFirstAllowedPath = (allowedPaths = []) => {
  const firstRoute = STAFF_ROUTE_ORDER.find((path) => isPathAllowed(path, allowedPaths));
  return firstRoute || '/';
};
